export const MISC_SUBTAB_CAPS = {
  platform: 'admin_panel_platform_management',
  tabsOrdering: 'admin_panel_tabs_ordering',
  currencyConversion: 'admin_panel_currency_conversion',
} as const;

export interface PlatformSettingRow {
  id: number;
  key: string;
  value: string;
  description: string;
  updated_at: string | null;
}

export interface AdminTabRow {
  id: number;
  key: string;
  label: string;
  display_order: number;
  is_visible: boolean;
}

export interface AdminSubtabRow {
  id: number;
  tab: number;
  tab_key: string;
  key: string;
  label: string;
  display_order: number;
  is_visible: boolean;
}
